import { useCallback, useEffect, useState } from "react";

const useReducer = <State, Action>(
  reducer: (state: State, action: Action) => State,
  initialState: State,
  onAction?: (state: State, action: Action) => void
): [State, (action: Action) => void] => {
  const [frame, setFrame] = useState<{ state: State; action: Action | null }>({
    action: null,
    state: initialState,
  });
  const dispatch = useCallback(
    (action: Action) => {
      setFrame((oldState) => ({
        state: reducer(oldState.state, action),
        action,
      }));
    },
    [reducer]
  );
  useEffect(() => {
    if (!onAction) {
      return;
    }
    if (frame.action === null) {
      return;
    }
    onAction(frame.state, frame.action);
  }, [frame]); // eslint-disable-line react-hooks/exhaustive-deps
  return [frame.state, dispatch];
};

export default useReducer;
